import { useEffect } from "react";

const syncLocalStorage = (tableName, id, isExpanded) => {
  const storedData = localStorage.getItem(`${tableName}Toggle`);
  let parsedData = { ids: [] };
  if (storedData) {
    parsedData = JSON.parse(storedData);
  }
  if (!isExpanded) {
    if (!parsedData.ids.includes(id)) {
      parsedData.ids.push(id);
    }
  } else {
    const newIds = parsedData.ids.filter((el) => el !== id);
    parsedData = { ids: newIds };
  }
  localStorage.setItem(`${tableName}Toggle`, JSON.stringify(parsedData));
};

const ReactTableWrapperRow = ({
  row,
  rowClassName,
  minHeight,
  cellClassname,
  styles = {},
  cellOnClick,
  visibleColumns,
  expandConfig,
  onClickHandler,
  rowProps,
  tableName,
  //   isSetUrl = false,
}) => {
  const id = row?.original?.id;
  const propStyles = rowProps.styles ? rowProps.styles : {};
  const syncToggle = expandConfig.syncToggle;

  const rowOnClickHandler = () => {
    if (onClickHandler) {
      onClickHandler(row);
    }
  };

  useEffect(() => {
    if (!syncToggle) return;

    const storedData = localStorage.getItem(`${tableName}Toggle`);
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      if (parsedData.ids && parsedData.ids.includes(id)) {
        row.toggleRowExpanded();
      }
    }
  }, [syncToggle, tableName, id, row]);

  return (
    <>
      <tr
        className={`custom-table-row custom-table-row--dynamic ${rowClassName} ${
          rowProps.className ? rowProps.className : ""
        }`}
        onClick={rowOnClickHandler}
        style={{ height: `${minHeight}px`, ...styles.row, ...propStyles }}
        {...row.getRowProps()}>
        {row.cells.map((cell, i) => {
          return (
            <td
              {...cell.getCellProps()}
              title={cell.column.cellShowTitle ? cell.row.original[cell.column.id] : ""}
              className={cell.column.cellClassName ? cell.column.cellClassName : null}
              onClick={() => {
                cellOnClick && cellOnClick(row, cell);
                expandConfig?.expandOnRowClick && row.toggleRowExpanded();
                syncToggle && syncLocalStorage(tableName, id, row.isExpanded);
              }}
              style={styles.cell}>
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
      {row.isExpanded ? (
        <tr className="custom-table-row-expansion">
          <td colSpan={visibleColumns.length}>
            {/* {expandConfig?.subComponent && expandConfig?.subComponent({ row })} */}
            <expandConfig.subComponent row={row} />
          </td>
        </tr>
      ) : null}
    </>
  );
};

export default ReactTableWrapperRow;
